function openCenteredPopup(
  url: string,
  windowName: string,
  win: Window,
  w: number,
  h: number,
) {
  const y = win.outerHeight / 2 + win.screenY - h / 2
  const x = win.outerWidth / 2 + win.screenX - w / 2
  return win.open(
    url,
    windowName,
    `location=yes, popup=yes, width=${w}, height=${h}, top=${y}, left=${x}`,
  )
}

export default openCenteredPopup
